// 2026-02-25 (Dave) — Reload-hiccup shield.
//
// The uvicorn dev server auto-restarts on backend file changes. During
// the ~200-500 ms window while FastAPI re-registers routes, any inbound
// request 404s because the router literally hasn't rebuilt yet. Screens
// that fire a fetch on mount (Firms, Users, Audit) would then paint a
// scary red "Request failed with status code 404" banner even though
// nothing was broken — a single browser refresh would work.
//
// This helper silently retries a promise-returning fetcher ONCE after a
// short delay if the first attempt looks like a reload-window blip:
//   • network error (no response at all), or
//   • HTTP 404 (route not yet registered)
//
// Anything else (401, 403, 500, real errors) surfaces immediately so we
// never mask a genuine bug.
//
// Usage:
//   const res = await retryOnReloadHiccup(() =>
//     axios.get(`${API}/admin/firms?include_inactive=true`)
//   );

const DEFAULT_DELAY_MS = 600;

export async function retryOnReloadHiccup(fetcher, { delayMs = DEFAULT_DELAY_MS } = {}) {
  try {
    return await fetcher();
  } catch (err) {
    const status = err?.response?.status;
    const looksLikeHiccup = status === 404 || (!err?.response && err?.request);
    if (!looksLikeHiccup) throw err;
    await new Promise((r) => setTimeout(r, delayMs));
    return fetcher();
  }
}
